<template>
  <a-form class="record-date-filter" layout="inline" :model="modelValue">
    <a-form-item label="开始日期">
      <a-date-picker :value="modelValue.startDate" value-format="YYYY-MM-DD" :allow-clear="allowClear"
        :placeholder="allowClear ? '不限' : '开始日期'" class="date-picker" @update:value="changeDate('startDate', $event)" />
    </a-form-item>
    <a-form-item label="结束日期">
      <a-date-picker :value="modelValue.endDate" value-format="YYYY-MM-DD" :allow-clear="allowClear"
        :placeholder="allowClear ? '不限' : '结束日期'" class="date-picker" @update:value="changeDate('endDate', $event)" />
    </a-form-item>
    <a-form-item label="快捷日期">
      <a-radio-group :value="quickValue" class="quick-date-group" button-style="solid"
        @update:value="emit('update:quickValue', $event)" @change="emit('quick-change', $event)">
        <a-radio-button v-for="option in quickDateOptions" :key="option.value" :value="option.value">
          {{ option.label }}
        </a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item>
      <a-space>
        <a-button type="primary" :loading="loading" @click="emit('search')">查询</a-button>
        <a-button @click="emit('reset')">重置</a-button>
      </a-space>
    </a-form-item>
  </a-form>
</template>

<script setup>
import { quickDateOptions } from "@/utils/recordDates";
const props = defineProps({
  modelValue: { type: Object, required: true },
  quickValue: { type: String, default: null },
  loading: { type: Boolean, default: false },
  allowClear: { type: Boolean, default: true },
});
const emit = defineEmits(["update:modelValue", "update:quickValue", "quick-change", "search", "reset"]);
const changeDate = (key, value) => {
  emit("update:modelValue", { ...props.modelValue, [key]: value || "" });
  emit("update:quickValue", null);
};
</script>

<style scoped>
.record-date-filter { row-gap: 12px; }
.record-date-filter :deep(.ant-form-item) { margin-bottom: 8px; }
.date-picker { width: 140px; }
.quick-date-group { display: flex; flex-wrap: wrap; row-gap: 6px; }
@media (max-width: 768px) {
  .record-date-filter { display: block; }
  .record-date-filter :deep(.ant-form-item) { display: flex; margin: 0 0 12px; }
  .record-date-filter :deep(.ant-form-item-label) { flex: 0 0 70px; }
  .record-date-filter :deep(.ant-form-item-control) { min-width: 0; flex: 1; }
  .date-picker { width: 100%; min-height: 44px; }
  .quick-date-group { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .quick-date-group :deep(.ant-radio-button-wrapper) { padding-inline: 4px; min-height: 44px; line-height: 42px; text-align: center; font-size: 12px; }
  .record-date-filter :deep(.ant-btn) { min-height: 44px; }
}
</style>
